import React, { useEffect, useState } from 'react';
import { initializePaddle } from '@paddle/paddle-js';
import { useTranslation } from 'react-i18next';

const FinopsPricingModal = ({ user, onClose }) => {
  const { t } = useTranslation();
  const [paddle, setPaddle] = useState(null);

  useEffect(() => {
    initializePaddle({
      environment: process.env.REACT_APP_PADDLE_ENV || 'sandbox',
      token: process.env.REACT_APP_PADDLE_CLIENT_TOKEN || 'test_token',
      eventCallback: function(event) {
        if (event.name === "checkout.completed") {
          console.log("Checkout successfully completed:", event);
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        }
      }
    }).then((paddleInstance) => {
      if (paddleInstance) setPaddle(paddleInstance);
    });
  }, []);

  const handleCheckout = (priceId) => {
    if (!paddle) return;
    paddle.Checkout.open({
      settings: { displayMode: "overlay" },
      items: [{ priceId: priceId, quantity: 1 }],
      customData: {
        user_id: user?.uid,
        product_type: 'greenops'
      }
    });
  };

  const scaleupPriceId = process.env.REACT_APP_PADDLE_SCALEUP_PRICE_ID || 'pri_01ky198bncq0v6q28a97a32xsd';
  const enterprisePriceId = process.env.REACT_APP_PADDLE_ENTERPRISE_PRICE_ID || 'pri_01ky19cj75tctz1rf32fjpezqh';

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
      background: 'rgba(0,0,0,0.8)', display: 'flex', justifyContent: 'center',
      alignItems: 'center', zIndex: 1000, padding: '20px'
    }}>
      <div className="glass-panel" style={{
        padding: '30px', maxWidth: '680px', width: '100%', position: 'relative',
        border: '1px solid rgba(79, 70, 229, 0.4)'
      }}>
        <button onClick={onClose} style={{
          position: 'absolute', top: '15px', right: '15px', background: 'none',
          border: 'none', color: 'var(--text-secondary)', cursor: 'pointer', fontSize: '1.2rem'
        }}>✕</button>

        <h2 style={{ textAlign: 'center', color: '#fff', marginBottom: '10px' }}>{t('finops.upgrade_modal.title')}</h2>
        <p style={{ textAlign: 'center', color: 'var(--text-secondary)', marginBottom: '30px' }}>
          {t('finops.upgrade_modal.subtitle')}
        </p>

        <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
          {/* Card ScaleUp */}
          <div style={{
            flex: '1 1 280px', padding: '20px', background: 'rgba(255,255,255,0.03)',
            borderRadius: '12px', border: '1px solid rgba(255,255,255,0.1)', display: 'flex', flexDirection: 'column'
          }}>
            <h3 style={{ color: '#E2E8F0', margin: '0 0 10px 0' }}>{t('finops.upgrade_modal.scaleup_title')}</h3>
            <p style={{ fontSize: '1.8rem', fontWeight: 'bold', color: 'var(--primary-color)', margin: '0 0 15px 0' }}>$149<span style={{ fontSize: '0.9rem', color: 'var(--text-secondary)' }}>{t('finops.upgrade_modal.scaleup_price_suffix')}</span></p>
            <ul style={{ paddingLeft: '20px', margin: '0 0 25px 0', color: 'var(--text-secondary)', fontSize: '0.85rem', lineHeight: '1.6' }}>
              <li>{t('finops.upgrade_modal.features.scaleup_1')}</li>
              <li>{t('finops.upgrade_modal.features.scaleup_2')}</li>
              <li>{t('finops.upgrade_modal.features.scaleup_3')}</li>
              <li>{t('finops.upgrade_modal.features.scaleup_4')}</li>
            </ul>
            <button className="btn-primary" style={{ marginTop: 'auto', width: '100%', padding: '10px' }}
                    onClick={() => handleCheckout(scaleupPriceId)} disabled={!paddle}>
              {paddle ? t('finops.upgrade_modal.btn_scaleup') : t('app.loading')}
            </button>
          </div>

          {/* Card Enterprise */}
          <div style={{
            flex: '1 1 280px', padding: '20px', background: 'rgba(255,255,255,0.03)',
            borderRadius: '12px', border: '1px solid rgba(79, 70, 229, 0.4)', display: 'flex', flexDirection: 'column'
          }}>
            <h3 style={{ color: '#E2E8F0', margin: '0 0 10px 0' }}>{t('finops.upgrade_modal.enterprise_title')}</h3>
            <p style={{ fontSize: '1.8rem', fontWeight: 'bold', color: 'var(--primary-color)', margin: '0 0 15px 0' }}>{t('finops.upgrade_modal.enterprise_price')}</p>
            <ul style={{ paddingLeft: '20px', margin: '0 0 25px 0', color: 'var(--text-secondary)', fontSize: '0.85rem', lineHeight: '1.6' }}>
              <li>{t('finops.upgrade_modal.features.enterprise_1')}</li>
              <li>{t('finops.upgrade_modal.features.enterprise_2')}</li>
              <li>{t('finops.upgrade_modal.features.enterprise_3')}</li>
              <li>{t('finops.upgrade_modal.features.enterprise_4')}</li>
            </ul>
            <button className="btn-primary" style={{ marginTop: 'auto', width: '100%', padding: '10px', background: 'var(--primary-color)' }}
                    onClick={() => handleCheckout(enterprisePriceId)} disabled={!paddle}>
              {paddle ? t('finops.upgrade_modal.btn_enterprise') : t('app.loading')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinopsPricingModal;
